/* ATAS USA — lightweight motion (scroll reveals + parallax). ~1.5KB, no dependencies.
   Respects prefers-reduced-motion and the Shopify theme editor. */
(function () {
  if (window.__atxMotion) return;
  window.__atxMotion = true;

  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  doc.classList.add('atx-js');

  var io = null;
  if (!reduce && !design && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('[data-atx-reveal]:not(.is-in)');
    for (var i = 0; i < els.length; i++) {
      if (io) io.observe(els[i]);
      else els[i].classList.add('is-in');
    }
  }

  var layers = [];
  var ticking = false;
  function collect() { layers = Array.prototype.slice.call(document.querySelectorAll('[data-atx-parallax]')); }
  function update() {
    ticking = false;
    if (window.innerWidth < 750) return;
    var vh = window.innerHeight;
    for (var i = 0; i < layers.length; i++) {
      var el = layers[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var speed = parseFloat(el.getAttribute('data-atx-parallax')) || 0.12;
      var offset = (r.top + r.height / 2 - vh / 2) * -speed;
      el.style.setProperty('--atx-shift', offset.toFixed(1) + 'px');
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  function init(scope) {
    reveal(scope);
    if (!reduce) { collect(); update(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  if (!reduce) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var els = e.target.querySelectorAll('[data-atx-reveal]');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    collect(); update();
  });
})();
